import Index from './Index.vue';
import Supervisor from './Supervisor.vue';
import AuditLog from './AuditLog.vue';
import { frontendURL } from '../../../helper/URLHelper';

// QM §5.4.3 Agent-facing Queues screen: self-take from queues the agent is a member of.
// The two supervisor screens (§5.5 overview, §5.9 audit log) sit alongside it: the
// QueueSupervision permission they require can belong to non-admin roles, so the
// role list stays open here and each screen gates its own body on the permission.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/queues'),
      name: 'agent_queues_dashboard',
      roles: ['administrator', 'agent'],
      component: Index,
    },
    {
      path: frontendURL('accounts/:accountId/queues/supervisor'),
      name: 'queues_supervisor',
      roles: ['administrator', 'agent'],
      component: Supervisor,
    },
    {
      path: frontendURL('accounts/:accountId/queues/audit'),
      name: 'queues_audit',
      roles: ['administrator', 'agent'],
      component: AuditLog,
    },
  ],
};
